/**
 * CopyButton — One-click copy to clipboard with visual feedback.
 *
 * Used throughout the Opportunities feature for copying to Salesforce.
 */

import React, { useState } from 'react';
import { Copy, Check } from 'lucide-react';
import './CopyButton.css';

function CopyButton({ text, label = 'Copy', className = '', size = 14, showLabel = false }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async (e) => {
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  return (
    <button
      className={`copy-btn ${copied ? 'copy-btn-copied' : ''} ${className}`}
      onClick={handleCopy}
      title={copied ? 'Copied!' : label}
      aria-label={copied ? 'Copied to clipboard' : label}
    >
      {copied ? <Check size={size} /> : <Copy size={size} />}
      {showLabel && <span className="copy-btn-label">{copied ? 'Copied!' : label}</span>}
    </button>
  );
}

export default CopyButton;
